import { apiService } from './api.service';
import { API_ENDPOINTS } from '../config/api';

export interface RequisicionItemPayload {
    medicamento_id: string;
    cantidad: number;
    precio_estimado: number;
    subtotal: number;
}

export interface CreateRequisicionPayload {
    id_requisicion?: string | null;
    idbodega: string;
    fecha: string;
    solicitante_id: string;
    prioridad: string;
    observaciones: string;
    total: number;
    detalles: RequisicionItemPayload[];
}

export const requisicionesService = {
    async create(data: CreateRequisicionPayload) {
        return apiService.post(API_ENDPOINTS.REQUISICIONES_CREATE, data);
    },

    async createBorrador(data: CreateRequisicionPayload) {
        return apiService.post(API_ENDPOINTS.REQUISICIONES_CREATE_BORRADOR, data);
    },

    async anular(id: string) {
        const response = await apiService.post<any>(API_ENDPOINTS.REQUISICIONES_ANULAR, { id_requisicion: id });
        return response.data || response;
    },

    async aprobar(id: string) {
        const response = await apiService.post<any>(API_ENDPOINTS.REQUISICIONES_APROBAR, { id_requisicion: id });
        return response.data || response;
    },

    async rechazar(id: string, motivo: string) {
        const response = await apiService.post<any>(API_ENDPOINTS.REQUISICIONES_RECHAZAR, { id_requisicion: id, motivo });
        return response.data || response;
    },

    async getAll(filters?: { idbodega?: string, fecha_inicio?: string, fecha_fin?: string, estado?: string }) {
        let url = API_ENDPOINTS.REQUISICIONES;

        if (filters) {
            const params = new URLSearchParams();
            if (filters.idbodega) params.append('idbodega', filters.idbodega);
            if (filters.fecha_inicio) params.append('fecha_inicio', filters.fecha_inicio);
            if (filters.fecha_fin) params.append('fecha_fin', filters.fecha_fin);
            if (filters.estado) params.append('estado', filters.estado);

            const queryString = params.toString();
            if (queryString) {
                url += `?${queryString}`;
            }
        }

        const response = await apiService.get<any>(url);

        // Retornar data si viene envuelto, o response directo si es array
        const result = response.data || response;
        return result;
    },

    async getDetalle(id: string) {
        const response = await apiService.get<any>(API_ENDPOINTS.REQUISICIONES_DETALLE, true, {
            params: {
                id
            }
        });
        return response.data || response;
    },

    async getPrincipiosActivos(search: string) {
        const response = await apiService.get<any>(API_ENDPOINTS.REQUISICIONES_PRINACTIVOS, true, {
            params: {
                search
            }
        });
        return response.data || response;
    },

    async createPrincipioActivo(data: { nombre_sustancia: string, concentracion: string, forma_farmaceutica: string, created_by?: string | number }) {
        return apiService.post(API_ENDPOINTS.REQUISICIONES_CREAPRINCIPIO, data);
    }
};
